import React, { useEffect, useRef } from 'react';
import {
  AppBar,
  Button,
  CircularProgress,
  CssBaseline,
  Fab,
  Hidden,
  IconButton,
  Toolbar,
} from "@material-ui/core";
import { useStylesBA, useStylesCAB } from "../../../../../St/comps/UseStyle";
import toast, { Toaster } from "react-hot-toast";
import CloseIcon from "@material-ui/icons/Close";
import SearchIcon from "@material-ui/icons/Search";
import AddBoxIcon from "@material-ui/icons/AddBox";
import SaveIcon from "@material-ui/icons/Save";
import PrintIcon from "@material-ui/icons/Print";
import { Fragment } from "react";
import {
  EReceiptValidateSchema,
  PrepareDataWithOmla,
  ReFormatingData,
} from "../../../../../services/EReceiptVoucher-service";
import { useState } from "react";
import { cellS, headerS, stElemnt } from "../../../../../St/comps/cStyle";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Scanner, ScannerOutlined } from "@material-ui/icons";
import { paymentType } from "../components/ReceiptVoucher-typeFilter";
import Delete from "@material-ui/icons/Delete";
import { insh, sto } from "../../../../../Context/InshData";
import SearchReaceiptCon from "../components/SearchRecipts/SearchReaceiptCon";
import { uri } from '../../../../../help/Api';
import axios from 'axios';
import ButtonsSearch from '../components/ButtonsSearch';
import { reloadGetsSanad } from './EReceiptVoucher';
import DeleteConfirmDialog from '../../../../../components/DeleteConfirmDialog';
import SanadsPrint from '../../../../../Reviews/Accounts/voucharPrint/SanadsPrint';

var columnsInv = [
  { title: "الرقم", field: "id", headerStyle: headerS, cellStyle: cellS },
  { title: "التاريخ", field: "date", headerStyle: headerS, cellStyle: cellS },
  { title: "المبلغ", field: "val", headerStyle: headerS, cellStyle: cellS },
  {
    title: "مندوب المبيعات",
    field: "empName",
    headerStyle: headerS,
    cellStyle: cellS,
  },
  {
    title: "المرجع",
    field: "check_no",
    headerStyle: headerS,
    cellStyle: cellS,
  },
  {
    title: "الحساب",
    field: "custName",
    headerStyle: headerS,
    cellStyle: cellS,
  },
  { title: "البيان", field: "notes", headerStyle: headerS, cellStyle: cellS },
];

export default function EReceiptVoucherAppBar(props) {
  const {
    submit,
    isDialog,
    onClose,
    prmis,
    update,
    defaultV,
    submitting,
    onShow,
    object,
    URL,
    formType,
    getRow,
    AutoOptions,
    selectCustomer,
    valueInv,
    invOptions,
    setInvOptions,
    setValueInv,
    setselectCustomer,
    branch,
    branchT,
    setBranchT,
    AutoOptionsB,
    setBranch,
    setOptionsStocks,
    changAutoCustomers,
    endBalance,
    setEndBalance,
    setOptionsCustomers,
    optionsCustomers,
    setListSelectApi,
    file,
    addArchaive,
    setFiles,
    files,
    showBalance,
    db_name
  } = props;

  let his = useHistory();
  const { t } = useTranslation(["forms"]);
  const [isSnackOper, setIsSnackOper] = useState(false);
  const [snackText, setSnackText] = useState("");
  const [valueCustomers, setValueCustomers] = useState({});


  const [openSearchMdl, setOpenSearchMdl] = useState(false);
  const [openButtonsSearch, setOpenButtonsSearch] = useState(false);
  const [procIdSearch, setProcIdSearch] = useState(0);
  const [rowUpdate, setRowUpdate] = useState({});
  const isSavingRef = useRef(false);


  const clasBA = useStylesBA();
  const clasCAB = useStylesCAB();
  let type = 1;
  let tname = "0";
  const styBtn = {
    dis: { color: "#3b773d", background: "#4fa152" },
    undis: { color: "#fff" },
  };

  const newEReceipt = () => {
    setOpenButtonsSearch(false);
    setProcIdSearch(0);
    setEndBalance(0.00);
    setFiles([]);
    reloadGetsSanad("sandq", branch.id, onShow, defaultV);
  };
  const addChangds = () => {
    object.date =
      moment(object.date).format("YYYY-MM-DD") +
      moment(new Date()).format(" h:mm A");
    object.branch = formType === "edit" && !props.isDialogData ? branchT : props.isDialogData ? props.invData.branch : branch.id == -1 ? sto.branchi : branch.id;
  };

  const onSubmitHandle = (isPrint, isLarge = false) => {
    if (object.customer == null || object.customer === "") {
      alert("برجاء اختيار العميل");

    } else if (object.val == null || object.val === "") {
      alert("برجاء ادخال المبلغ المستلم ");
    } else if (parseFloat(object.val) <= 0) {
      alert("برجاء ادخال المبلغ المستلم ");
    }
    else if (object.val1 == null || object.val1 === "") {
      alert("برجاء ادخال مبلغ الصندوق او البنك  ");
    } else if (prmis?.FORCECOST === true && object?.center?.id < 1) {
      alert("لا يمكنك إتمام العملية برجاء التأكد من اختيار مركز التكلفة");
    } else {
      onSubmitHandle2(isPrint, isLarge);
    }
  };


  const onSubmitHandle2 = (isPrint, isLarge = false) => {
    addChangds();
    let nData = PrepareDataWithOmla(object);

    console.log("the data is", nData);
    const data = {
      sandQ: nData,
      parms: {
        bankAcc: parseInt(object?.bank?.acc_no ?? 0),
        stockAcc: parseInt(object?.stock?.acc_no ?? 0),
        acc_no: parseInt(object?.customer?.acc_no ?? 0),
        user: parseInt(object?.emp?.id ?? 0),
        cust_name: object?.customer?.name ?? "",
      },
      stor: { invsType: 0 },
      db_name: db_name,
    };

    EReceiptValidateSchema.validate(nData, { abortEarly: false })
      .then(async () => {
        if (formType == "edit") {
          if (isPrint) handlePrint(nData, nData, isLarge);
          else await update(data).then((res) => {
            if (files?.length > 0) { addArchaive(res.data); }
            if (res.data?.id == null) {
              toast.error(res.data);
              if (props.isDialogData === true) {
                props.onClose();
              }
            } else {
              if (props.isDialogData === true) {
                props.onClose();
              }
            }

          });
        } else {
          await submit(data).then((res) => {
            if (files?.length > 0) { addArchaive(res.data); }
            if (isPrint) handlePrint(res.data, nData, isLarge);
            // toast.success('تم إضافة السند')
            else { newObject(); }

          });
        }
      })
      .catch((err) => {
        //toast.error(err.errors[0]);
      });
  };
  const [infoPrint, setInfoPrint] = useState(false);
  const [dataPrint, setDataPrint] = useState({});
  const closePrint = (type) => {
    newEReceipt();
    setDataPrint({});
    setInfoPrint(false);
  };
  const handlePrint = (rptdata, oldObject, isLarge) => {
    const info = {
      temp: 1,
      columns: columnsInv,
      data: rptdata,
      custN: "استلمت من السيد",
      from: "القبض",
      title: "سند قبض - خارجي",
      subTitle: "External Receipt Voucher",
      label: "استلمت من السيد",
      endBalance: formType == "new" ? parseFloat(endBalance - rptdata.val) : parseFloat(endBalance ?? 0),
      auto: {
        empName: oldObject.emp.name,
        center: oldObject.center.name,
        custName: oldObject.customer.name,
        omlaName: oldObject.cust_omla.name,
        stockName:
          rptdata?.type == 1 ? oldObject.stock?.name : oldObject.bank?.name,
        type: t(paymentType[rptdata?.type - 1].name),
      },
      //   fDate:dateFrom,tDate:dateTo,
      Date: moment(rptdata.date).format("YYYY-MM-DD"),
      ElmntShow: true,
      isLarge: isLarge,
      SHOW_BALANCE: prmis?.SHOW_BALANCE ?? false,
      db_name:db_name,
    };
    setDataPrint(info);
    setInfoPrint(true);
    // localStorage.setItem("iInfos", JSON.stringify(info));
    // if (isLarge) his.push({ pathname: "/voucher2" });
    // else his.push({ pathname: "/SC" });
  };
  const onRowDialog = () => {
    if (props.isDialogData == true) {

      let data = props.invData;
      const data2 = {
        ...data,
        acc_name: data.acc_name,
        custName: data.acc_name,
        emp_id: data.sales_emp,
      }
      const valuecust = AutoOptions.Customers.find((obj) => obj.id === props.invData.cust_id);
      const tb = {
        CustomersSearch: !valuecust ? true : false,
        parms: {
          iempid: sto.empi,
          withOmlat: true,
          tname: "search",
          cust_id: props.invData.cust_id,
          cust_name: '',
          db_name: db_name,
        },
      };

      axios
        .post(uri + "Res", tb)
        .then((res) => {
          if (!valuecust) { setListSelectApi(res?.data?.Customers); setOptionsCustomers([...res?.data?.Customers, ...AutoOptions.Customers]); }
          const optinsNew = {
            ...AutoOptions,
            Customers: valuecust ? AutoOptions.Customers : [...res?.data?.Customers, ...AutoOptions.Customers],
          };
          const valueCustomer = valuecust ? valuecust : res?.data?.Customers[0];
          console.log("the rowssss is", data2)
          let FormatedData = ReFormatingData(data2, optinsNew);
          onShow(FormatedData, "edit");
          changAutoCustomers(valueCustomer, true);
          setOpenSearchMdl(false);
        })
        .catch((error) => {
        });

    }

  };

  useEffect(() => {
    onRowDialog();
  }, []);

  const onRowClick = (row) => {
    setBranchT(row?.branch);
    setProcIdSearch(row?.id);
    setOpenButtonsSearch(true);
    const valuecust = AutoOptions.Customers.find((obj) => obj.id === row.cust_id);
    const tb = {
      Stocks: true, // Error // out
      CustomersSearch: !valuecust ? true : false,
      parms: {
        branch: row?.branch,
        ibranchid: row?.branch,
        iempid: sto.empi,
        withOmlat: true,
        tname: "search",
        cust_id: row.cust_id,
        cust_name: '',
        id: 1,
        db_name: db_name,
      },
    };

    axios
      .post(uri + "Res", tb)
      .then((res) => {
        setOptionsStocks(res.data?.Stocks);
        if (!valuecust) { setListSelectApi(res?.data?.Customers); setOptionsCustomers([...res?.data?.Customers, ...AutoOptions.Customers]); }
        const optinsNew = {
          ...AutoOptions,
          Customers: valuecust ? AutoOptions.Customers : [...res?.data?.Customers, ...AutoOptions.Customers],
          Stocks: res.data?.Stocks,
        };
        const valueCustomer = valuecust ? valuecust : res?.data?.Customers[0];
        console.log("the valuecaust is", valueCustomer)
        onRowClickAfter({ ...row }, optinsNew);
        changAutoCustomers(valueCustomer, true);
      })
      .catch((error) => {
      });
  };


  const onRowClickAfter = (row, optinsNew) => {
    // console.log("the row is", row)
    setBranchT(row?.branch);

    console.log("the roptinsNewow is", optinsNew);
    const tb = {
      wait: true,
      SandInv: true,
      parms: {
        icurr: row?.cust_id,
        branch: row?.branch,
        id: row.id,
        db_name: db_name,
      },
    };

    axios
      .post(uri + "GetD", tb)
      .then((res) => {
        setInvOptions([...res.data?.invCredit]);
        setValueInv(res.data?.invCredit[0]);
        setselectCustomer(true);
        let newObject = {
          ...row,
          proc_id: res.data?.invCredit[0].procId,
        };
        let FormatedData = ReFormatingData(newObject, optinsNew);

        onShow(FormatedData, "edit");
      })
      .catch((error) => {
        let FormatedData = ReFormatingData(row, optinsNew);
        onShow(FormatedData, "edit");
      });
    // console.log("type is", FormatedData);
    setOpenSearchMdl(false);


  };
  const onClickButton = async (procId, type) => {
    const tb = {
      wait: true,
      ButtonSearchSand: true,
      stor: sto,
      parms: {
        tname: type,
        branch: branch.id == -1 ? sto.branchi : branch.id,
        iprocid: procId,
        iempid: sto.empi,
        type: "0",
        db_name: db_name
      },
    };
    axios
      .post(uri + "GetD", tb)
      .then((res) => {
        setProcIdSearch(res.data?.Sand_data?.id);
        if (res.data?.Sand_data.id > 0) {
          onRowClick({
            ...res.data.Sand_data,

            acc_name: res?.data?.Sand_data?.acc_name,
            custName: res.data.Sand_data?.acc_name,
            emp_id: res.data.Sand_data?.sales_emp,
          });
        }
      })
      .catch((error) => {
      });
  };
  const [transition, setTransition] = React.useState(undefined);
  const [isInternal, setIsInternal] = useState(false);
  const handCloseDw = () => {
    setOpenSearchMdl(false);
  };

  const handOpenDw = (Transition) => {
    setTransition(() => Transition);
    setOpenSearchMdl(true);
  };
  const [loading, setLoading] = useState(insh.LoadAndSucc);

  const [success, setSuccess] = useState(insh.LoadAndSucc);
  const [confirmDialog, setConfirmDialog] = useState({ isOpen: false });

  const ButtonLoading = (prop) => {
    setLoading({ ...loading, [prop]: true });
  };
  const timer = React.useRef();

  const ButtonSuccess = (prop, state) => {
    timer.current = window.setTimeout(() => {
      setLoading({ ...loading, [prop]: false });
      setSuccess({ ...success, [prop]: true });
      if (
        prop == "delete"
      ) {
        if (state) newObject();
      }
      timer.current = window.setTimeout(() => {
        setSuccess({ ...success, [prop]: false });
      }, 100);
    }, 1000);
  };
  const newObject = () => {
    newEReceipt();
  };
  const onDeleteHandle = async (e) => {

    await e.preventDefault();
    setConfirmDialog({ ...confirmDialog, isOpen: false });
    ButtonLoading("delete");
    let Urls = null;
    if (sto.db_name === "" || sto.db_name === null) {
      Urls = `SandSQKh_R_RS_?id=${object.id}&&branch=${object.branch}`
    } else {
      Urls = `SandSQKh_R_RS_?id=${object.id}&&branch=${object.branch}&&db_name=${db_name}`
    }
    await axios.delete(uri + Urls).then(res => {

      if (parseFloat(res.data) > 0) {
        toast.success("لقد تم حذف السند بنجاح");

        if (props.isDialogData === true) {
          props.onClose();
        } else { ButtonSuccess("delete", true); }

      } else {
        toast.error(res.data);
        if (props.isDialogData === true) {
          { props.onClose(); }
        } else { ButtonSuccess("delete", true); }

      }


    }).catch(err => {
      if (err.response?.data?.Message != null) {
        toast.error(err.response?.data?.Message);
      } else
        console.log("eror", err)
      ButtonSuccess("delete", false);
      toast.error("not delete ")
    })
  };

  const backHome = () => {
    if (isDialog) onClose();
    else {
      his.push({ pathname: "/" });
      window.location.reload(false);
    }
  };

  return (
    <React.Fragment>
      <Toaster />
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clasBA.appBarBASal}
        style={{ backgroundColor: "#808080" }}
      >
        <Toolbar className={clasBA.ToolbarBA} variant="dense">
          {props.isDialogData ? (
            <>
              <Hidden smUp={["sm"]}>
                <IconButton
                  edge="start"
                  color="inherit"
                  aria-label="backH"
                  onClick={props.onClose}
                >
                  <CloseIcon />
                </IconButton>


              </Hidden>

              <Hidden only={["xs"]}>
                <Button
                  style={styBtn.undis}
                  onClick={props.onClose}
                  startIcon={<CloseIcon />}
                >
                  {t("exit")}
                </Button>
              </Hidden></>
          ) :
            (
              <>
                <Hidden smUp={["sm"]}>
                  <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="backH"
                    onClick={backHome}
                  >
                    <CloseIcon />
                  </IconButton>
                  <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="searsh"
                    onClick={() => setOpenSearchMdl(true)}
                    disabled={prmis?.Se}
                  >
                    <SearchIcon />
                  </IconButton>
                  <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="handNew"
                    onClick={newEReceipt}
                  >
                    <AddBoxIcon />
                  </IconButton>
                </Hidden>

                <Hidden only={["xs"]}>
                  <Button
                    style={styBtn.undis}
                    onClick={backHome}
                    startIcon={<CloseIcon />}
                  >
                    {t("exit")}
                  </Button>
                  <Button
                    style={styBtn.undis}
                    disabled={prmis?.Se}
                    onClick={() => setOpenSearchMdl(true)}
                    startIcon={<SearchIcon />}
                  >
                    {t("search")}
                  </Button>
                  <Button
                    style={styBtn.undis}
                    onClick={newEReceipt}
                    startIcon={<AddBoxIcon />}
                  >
                    {t("new")}
                  </Button>


                </Hidden></>
            )
          }
          {!props.isDialogData && (
            <Hidden only={["xs"]}>
              <ButtonsSearch
                {...{
                  onClickButton, openButtonsSearch, procIdSearch, setOpenButtonsSearch
                }}
              />
            </Hidden>
          )}

          <div className={clasBA.growBA} />

          <Hidden smUp={["sm"]}>
            {formType == "edit" && (
              <div className={clasCAB.wrapperCAB}>
                <Fab
                  size="medium"
                  color="primary"
                  style={{
                    ...stElemnt.all.iconBtn,
                    backgroundColor: "#808080",
                  }}
                  // disabled={submitting}
                  disabled={submitting || prmis.De}
                  className={clasCAB.buttonSuccessCAB}
                  onClick={(e) => {
                    setConfirmDialog({
                      isOpen: true,
                      onConfirm: () => {
                        onDeleteHandle(e);
                      },
                    })
                  }}
                >
                  <Delete />
                </Fab>

                {submitting && (
                  <CircularProgress
                    size={56}
                    className={clasCAB.fabProgressCAB}
                  />
                )}
              </div>
            )}
            <div className={clasCAB.wrapperCAB}>
              <Fab
                size="medium"
                color="primary"
                style={{ ...stElemnt.all.iconBtn, backgroundColor: "#808080" }}
                className={clasCAB.buttonSuccessCAB}
                disabled={
                  submitting ||
                  (formType == "new" ? prmis?.Sa || prmis?.Pr : prmis?.Pr)
                }
                onClick={() => {
                  onSubmitHandle(true);
                }}
              >
                <Scanner />
              </Fab>
              {submitting && (
                <CircularProgress
                  size={56}
                  className={clasCAB.fabProgressCAB}
                />
              )}
            </div>
            <div className={clasCAB.wrapperCAB}>
              <Fab
                size="medium"
                color="primary"
                style={{ ...stElemnt.all.iconBtn, backgroundColor: "#808080" }}
                className={clasCAB.buttonSuccessCAB}
                disabled={
                  submitting ||
                  (formType == "new" ? prmis?.Sa || prmis?.Pr : prmis?.Pr)
                }
                onClick={() => {
                  onSubmitHandle(true, true);
                }}
              >
                <PrintIcon />
              </Fab>
              {submitting && (
                <CircularProgress
                  size={56}
                  className={clasCAB.fabProgressCAB}
                />
              )}
            </div>

            <div className={clasCAB.wrapperCAB}>
              <Fab
                size="medium"
                color="primary"
                style={{ ...stElemnt.all.iconBtn, backgroundColor: "#808080" }}
                className={clasCAB.buttonSuccessCAB}
                disabled={
                  submitting || (formType == "new" ? prmis?.Sa : prmis?.Up)
                }
                onClick={() => onSubmitHandle(false)}
              >
                {" "}
                <SaveIcon />
              </Fab>

              {submitting && (
                <CircularProgress
                  size={56}
                  className={clasCAB.fabProgressCAB}
                />
              )}
            </div>
          </Hidden>

          <Hidden only={["xs"]}>
            {formType == "edit" && (
              <>
                <div className={clasCAB.wrapperCAB}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className={clasCAB.buttonSuccessCAB}
                    startIcon={<Delete />}
                    style={{
                      ...stElemnt.all.iconBtn,
                      backgroundColor: "#808080",
                    }}
                    disabled={submitting || prmis.De}
                    onClick={(e) => {
                      setConfirmDialog({
                        isOpen: true,
                        onConfirm: () => {
                          onDeleteHandle(e);
                        },
                      })
                    }}
                  >
                    حـذف
                  </Button>

                  {submitting && (
                    <CircularProgress
                      size={24}
                      className={clasCAB.buttonProgressCAB}
                    />
                  )}
                </div>

              </>
            )}

            <Fragment>
              <div className={clasCAB.wrapperCAB}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  className={clasCAB.buttonSuccessCAB}
                  startIcon={<ScannerOutlined />}
                  style={{
                    ...stElemnt.all.iconBtn,
                    backgroundColor: "#808080",
                  }}
                  disabled={
                    submitting ||
                    (formType == "new" ? prmis?.Sa || prmis?.Pr : prmis?.Pr)
                  }
                  onClick={() => onSubmitHandle(true)}
                >
                  {" "}
                  {t("cashier-view")}
                </Button>

                {submitting && (
                  <CircularProgress
                    size={24}
                    className={clasCAB.buttonProgressCAB}
                  />
                )}
              </div>
              <div className={clasCAB.wrapperCAB}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  className={clasCAB.buttonSuccessCAB}
                  startIcon={<PrintIcon />}
                  style={{
                    ...stElemnt.all.iconBtn,
                    backgroundColor: "#808080",
                  }}
                  disabled={
                    submitting ||
                    (formType == "new" ? prmis?.Sa || prmis?.Pr : prmis?.Pr)
                  }
                  onClick={() => onSubmitHandle(true, true)}
                >
                  {" "}
                  {formType == "edit" ? t("print") : t("save-print")}
                </Button>
              </div>
            </Fragment>
            <div className={clasCAB.wrapperCAB}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                style={{ ...stElemnt.all.iconBtn, backgroundColor: "#808080" }}
                className={clasCAB.buttonSuccessCAB}
                disabled={
                  submitting || (formType == "new" ? prmis?.Sa : prmis?.Up)
                }
                onClick={() => onSubmitHandle(false)}
                startIcon={<SaveIcon />}
              >
                {formType == "edit" ? t("save-update") : t("save")}
              </Button>
            </div>
          </Hidden>

        </Toolbar>
      </AppBar>
      {confirmDialog.isOpen && (
        <DeleteConfirmDialog
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog}
        />
      )}
      {openSearchMdl && (
        <SearchReaceiptCon
          {...{
            openSearchMdl, handCloseDw,
            onRowClick, URL, type, tname, AutoOptions, transition, isInternal,
            AutoOptionsB
          }}
        />
      )}
      {infoPrint ? <SanadsPrint dataPrint={dataPrint} closePrint={closePrint} infoPrint={infoPrint} /> : null}
    </React.Fragment>
  );
}
